export default {"src":"/_next/static/media/time_diff.428a44f6.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};